import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const createProjectPhase = createAsyncThunk(
  'projectBilling/createPhase',
  async ({ body }, { signal, rejectWithValue }) => {
    try {
      const res = await axios.post(`${API_URL}/api/invoice/project/phase`, body, { signal });
      return res.data;
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('projectBilling/createPhase failed', e);
      return rejectWithValue(e?.response?.data?.message || e?.message || 'Failed to create phase');
    }
  }
);

export const updateProjectPhase = createAsyncThunk(
  'projectBilling/updatePhase',
  async ({ body }, { signal, rejectWithValue }) => {
    try {
      const res = await axios.put(`${API_URL}/api/invoice/project/phase`, body, { signal });
      return res.data;
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('projectBilling/updatePhase failed', e);
      return rejectWithValue(e?.response?.data?.message || e?.message || 'Failed to update phase');
    }
  }
);

export const createPlannedInvoice = createAsyncThunk(
  'projectBilling/createPlannedInvoice',
  async ({ body }, { signal, rejectWithValue }) => {
    try {
      const res = await axios.post(`${API_URL}/api/invoice/project/invoice`, body, { signal });
      return res.data;
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('projectBilling/createPlannedInvoice failed', e);
      return rejectWithValue(e?.response?.data?.message || e?.message || 'Failed to create planned invoice');
    }
  }
);

export const updatePlannedInvoice = createAsyncThunk(
  'projectBilling/updatePlannedInvoice',
  async ({ body }, { signal, rejectWithValue }) => {
    try {
      const res = await axios.put(`${API_URL}/api/invoice/project/invoice`, body, { signal });
      return res.data;
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('projectBilling/updatePlannedInvoice failed', e);
      return rejectWithValue(e?.response?.data?.message || e?.message || 'Failed to update planned invoice');
    }
  }
);

export const setDefaultBillPayer = createAsyncThunk(
  'projectBilling/setDefaultBillPayer',
  async ({ body }, { signal, rejectWithValue }) => {
    try {
      const res = await axios.post(`${API_URL}/api/invoice/project/default/bill/payer`, body, { signal });
      return res.data;
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('projectBilling/setDefaultBillPayer failed', e);
      return rejectWithValue(e?.response?.data?.message || e?.message || 'Failed to update default bill payer');
    }
  }
);

export const fetchRecentBillPayers = createAsyncThunk(
  'projectBilling/fetchRecentBillPayers',
  async (_, { signal, rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_URL}/api/invoice/project/bill/payer/recent`, { signal });
      return res.data;
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('projectBilling/fetchRecentBillPayers failed', e);
      return rejectWithValue(e?.message || 'Failed to fetch recent bill payers');
    }
  }
);

export const searchBillPayers = createAsyncThunk(
  'projectBilling/searchBillPayers',
  async ({ billPayer, clientType }, { signal, rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_URL}/api/invoice/project/bill/payer/all`, {
        signal,
        params: { billPayer, clientType },
      });
      return res.data;
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('projectBilling/searchBillPayers failed', e);
      return rejectWithValue(e?.message || 'Failed to fetch bill payers');
    }
  }
);

export const addBillPayerToProject = createAsyncThunk(
  'projectBilling/addBillPayerToProject',
  async ({ body }, { signal, rejectWithValue }) => {
    try {
      const res = await axios.post(`${API_URL}/api/invoice/project/add/bill/payer`, body, { signal });
      return res.data;
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('projectBilling/addBillPayerToProject failed', e);
      return rejectWithValue(e?.response?.data?.message || e?.message || 'Failed to add bill payer');
    }
  }
);

const slice = createSlice({
  name: 'projectBilling',
  initialState: { error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) => action.type.startsWith('projectBilling/') && action.type.endsWith('/rejected'),
      (state, action) => {
        if (action?.meta?.aborted) return;
        state.error = action.payload || action.error?.message || null;
      }
    );
  },
});

export default slice.reducer;


